// @flow

export function isRetriableError(error: string): boolean {
  return ['BP-DR-49'].includes(error);
}
